import {UmpireCompetitionSeason} from '../umpire-competition-season';
import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireSquad} from '../umpire-squad';
import {UmpireTeam} from '../umpire-team';

export interface UmpireComponentSquad
  extends UmpireComponent<UmpireComponentTypeEnum.SQUAD> {
  team: UmpireTeam;
  competition_season: UmpireCompetitionSeason;
  auto_pick: boolean;
  squad?: UmpireSquad;
}
